(function () {
  const style = document.createElement('style')
  style.type = 'text/css';
  style.appendChild(document.createTextNode(`
  .n-loader {
    align-content: center;
    margin: auto;
    box-sizing: border-box;
    width: 28px;
    height: 28px;
    animation-name: load;
    animation-duration: 1.3s;
    animation-iteration-count: infinite;
    animation-timing-function: cubic-bezier(0.53, 0.21, 0.29, 0.67);
    border-radius: 50%;
    border-width: 1.5px;
    border-style: solid;
    border-color: #7719aa #d9d9d9 #d9d9d9;
    border-image: initial;
  }
  .n-loaderTitle {
    margin: auto auto 5px auto;
    height: 19px;
    width: 88px;
    background: transparent;
    }
  #n-loadingNotification {
    display: flex;
    align-content: center;
    flex-direction: column;
    height: 50vh;
    justify-content: center;
  }
  @keyframes load {
    0% {
        transform: rotateZ(0deg);
    }
    100% {
        transform: rotateZ(360deg);
    }
  }
  @keyframes fade {
    0% {
    -webkit-transform: scale(1.2);
    transform: scale(1.2);
    opacity: 0;
    }
    15% {
        -webkit-transform: scale(1);
        transform: scale(1);
        opacity: 1;
    }
    85% {
        -webkit-transform: scale(1);
        transform: scale(1);
        opacity: 1;
    }
  }
  `));
  document.head.appendChild(style)
  const body = document.createElement('div')
  body.id = 'n-loadingNotification'
  const loadingContainer = document.createElement('div')
  loadingContainer.classList.add('n-loadingContainer')
  const loadingDiv = document.createElement('div')
  loadingDiv.classList.add('n-loader')
  loadingDiv.setAttribute('aria-live', 'polite')
  loadingDiv.setAttribute('aria-label', 'loading')
  const loadingTitle = document.createElement('div')
  loadingTitle.classList.add('n-loaderTitle')

  loadingContainer.appendChild(loadingDiv)
  body.appendChild(loadingTitle)
  body.appendChild(loadingContainer)
  document.getElementById('loadingPlaceholder').appendChild(body)
  window['loadTiming'] = new Date().getTime()
}
)()